<template>
  <div :class="$style.topbar">
    <div class="mr-4">
      <cui-fav-pages />
    </div>
    <div>
      <cui-select-building />
    </div>
    <div class="ml-4 mr-auto">
      <CuiSelectSchoolarYear />
    </div>
    <!-- <div
      class="mr-4 mr-sm-4"
      v-if="
        verifyAccess(['liste_eleves']) && schoolDetails.pack.studentLimit != -1
      "
    >
      <div class="d-flex align-items-center ml-4">
        <a-spin v-if="spinLoader" class="mr-1" />
        <span v-else :style="textColor" class="font-weight-bold">{{
          studentNumber
        }}</span>
        <span class="mx-1">/</span>
        <span class="text-muted">{{ schoolDetails.pack.studentLimit }}</span>
        <span class="ml-1 d-none d-sm-inline">élèves</span>
        <span class="ml-1 d-sm-none">él.</span>
      </div>
    </div> -->

    <!-- start notification section -->
    <div v-if="canViewNotifications()" class="mr-3 d-none d-sm-block">
      <cui-notification-menu />
    </div>
    <!-- end notification section -->

    <div
      v-if="verifyPackAccess('chat') != 'h' && verifyAccess(['all', 'chat'])"
      class="mr-4 d-none d-sm-block"
    >
      <a-tooltip placement="bottom" :title="$t('menu.chat')">
        <a-badge :count="unreadedMessages" :overflow-count="10">
          <a-button
            @click="chatPage"
            shape="circle"
            class="mt-1"
            :class="{
              disabledPack: verifyPackAccess('chat') == 'd',
            }"
            icon="wechat"
          />
        </a-badge>
      </a-tooltip>
    </div>
    <div class="mr-4 d-none d-sm-block">
      <cui-language-switcher />
    </div>
    <div>
      <cui-user-menu />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import CuiLanguageSwitcher from "./LanguageSwitcher";
import CuiNotificationMenu from "./NotificationMenu";
import CuiUserMenu from "./UserMenu";
import CuiFavPages from "./FavPages";
import CuiSelectBuilding from "./SelectBuilding";
import CuiSelectSchoolarYear from "./SelectSchoolarYear";
import store from "store";
import apiClient from "@/services/axios";
import tokenStorage from "@/services/tokenStorage";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      unreadedMessages: 0,
      test: false,
      titleLoop: null,
      spinLoader: true,
    };
  },
  components: {
    CuiUserMenu,
    CuiFavPages,
    CuiSelectBuilding,
    CuiSelectSchoolarYear,
    CuiLanguageSwitcher,
    CuiNotificationMenu,
  },
  created() {
    if (this.verifyAccess(["all", "chat"])) {
      apiClient.get("/chat/admin/unseenMessages").then((res) => {
        res.data.map((parent) => {
          this.unreadedMessages += parent.count;
        });
      });
      // apiClient.get("/students/studentsCount").then(({ data }) => {
      //   this.studentNumber = data;
      //   this.spinLoader = false;
      // });
      tokenStorage.waitForToken().then((token) => {
        if (!token) return;
        this.$socket.client.emit("adminJoin", {
          token,
          db: store.get("DB"),
        });
      });

      this.$socket.client.on("adminJoined", (data) => {
        // joined the room
      });

      this.$socket.client.on("messageNotification", (data) => {
        if (this.$router.currentRoute.path != "/chat") {
          this.unreadedMessages++;
          this.newNotify();
        }
        const audio = new Audio("/resources/notification.mp3");
        audio.play();
      });
    }
  },

  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings"),
    schoolDetails() {
      return (
        this.user.building.filter(
          (el) => el.dbName == this.settings.activeBuilding
        )[0] || {}
      );
    },
    // textColor() {
    //   if (this.studentNumber > this.schoolDetails.pack.studentLimit - 10) {
    //     return { color: "red" };
    //   } else if (
    //     this.studentNumber >
    //     this.schoolDetails.pack.studentLimit / 2
    //   ) {
    //     return { color: "#c9c734" };
    //   } else {
    //     return { color: "green" }; // No specific style
    //   }
    // },
  },

  methods: {
    ...mapActions("settings"),
    verifyPackAccess: function (item) {
      if (!item.buildingAccess) return "v";
      else {
        return this.schoolDetails.pack.access.edManager[item.buildingAccess];
      }
    },
    async chatPage() {
      if (this.verifyPackAccess("chat") == "d") return;
      this.unreadedMessages = 0;
      this.resetNotification();
      this.$router.push("/chat");
    },
    newNotify() {
      clearInterval(this.titleLoop);
      this.titleLoop = setInterval(() => {
        if (this.test) document.title = "Système de gestion";
        else document.title = "(" + this.unreadedMessages + ") " + "Messages";
        this.test = !this.test;
      }, 1500);
    },

    resetNotification() {
      clearInterval(this.titleLoop);
      document.title = "Système de gestion";
    },

    verifyAccess(accessRoles) {
      const existing = this.user.access;
      if (this.schoolDetails.pack.access.edManager["chat"] != "v") return false;
      if (existing.all) return true;
      if (
        existing.chat &&
        existing.chat.length > 0 &&
        existing.chat.find((e) => accessRoles.includes(e))
      )
        return true;
      else return false;
    },
    canViewNotifications() {
      const existing = this.user?.access || {};
      return (
        existing.all === true ||
        existing.notifications === true ||
        (Array.isArray(existing.notifications) &&
          existing.notifications.length > 0)
      );
    },
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
